"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2582],{

/***/ 73629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ FieldDescription; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36716);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96749);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);






var FieldDescription = function FieldDescription(props) {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
    css: [blockStyle, props.styles,  true ? "" : 0,  true ? "" : 0],
    children: props.children
  });
};
var blockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)("font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.caption */ .JB.caption, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .lineHeight.caption3 */ .Nv.caption3, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight.regular */ .Ue.regular, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .textColor.secondaryDarkColor */ .zP.secondaryDarkColor, ";display:block;padding:0 0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__/* .space.atom */ .D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 2582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ RadioButtonBlock; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./main/javascripts/components/form/Label.tsx
var Label = __webpack_require__(35183);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/form/RadioButton.tsx


var _excluded = ["styles", "label", "checked", "styleKey", "labelStyleKey", "borderColorStyleKey", "validate"],
    _excluded2 = ["name", "value", "onChange"],
    _excluded3 = ["onChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var RadioButton = function RadioButton(props) {
  var _props$styles = props.styles,
      styles = _props$styles === void 0 ? {} : _props$styles,
      label = props.label,
      checked = props.checked,
      _props$styleKey = props.styleKey,
      styleKey = _props$styleKey === void 0 ? "default" : _props$styleKey,
      _props$labelStyleKey = props.labelStyleKey,
      labelStyleKey = _props$labelStyleKey === void 0 ? "labelDarkStyle" : _props$labelStyleKey,
      _props$borderColorSty = props.borderColorStyleKey,
      borderColorStyleKey = _props$borderColorSty === void 0 ? "none" : _props$borderColorSty,
      validate = props.validate,
      input = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var exBlockStyle = styles.exBlockStyle,
      exInputStyle = styles.exInputStyle,
      exLabelStyle = styles.exLabelStyle,
      exLabelCheckedStyle = styles.exLabelCheckedStyle,
      exTextStyle = styles.exTextStyle;

  var name = input.name,
      value = input.value,
      onInputChange = input.onChange,
      attributes = (0,objectWithoutProperties/* default */.Z)(input, _excluded2);

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register;

  var _register = register(name, validate),
      onChange = _register.onChange,
      rest = (0,objectWithoutProperties/* default */.Z)(_register, _excluded3); // react hook formのonChangeと合成


  var onValueChange = function onValueChange(e) {
    void onChange(e);

    if (onInputChange) {
      onInputChange(e);
    }
  };

  var labelBaseStyles = checked ? [labelStyle[styleKey], labelCheckedStyle[styleKey], exLabelCheckedStyle] : [labelStyle[styleKey], radioButtonBorderColorStyle[borderColorStyleKey], exLabelStyle];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
    css: [blockStyle, exBlockStyle,  true ? "" : 0,  true ? "" : 0],
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", _objectSpread(_objectSpread({
      type: "radio",
      value: value,
      "aria-checked": checked,
      onChange: onValueChange,
      checked: checked,
      css: [inputStyle, exInputStyle,  true ? "" : 0,  true ? "" : 0]
    }, attributes), rest)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
      css: [labelBaseStyles, exTextStyle, labelColorStyle[labelStyleKey],  true ? "" : 0,  true ? "" : 0],
      children: label
    })]
  });
};
var blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:relative;display:inline-block;cursor:pointer;padding:0.5rem 0.75rem 0.5rem 0;vertical-align:middle;overflow:hidden;width:100%;box-sizing:border-box;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{padding:0.375rem 0.75rem 0.375rem 0;}" + ( true ? "" : 0),  true ? "" : 0);
var inputStyle =  true ? {
  name: "5i3i0l",
  styles: "position:absolute;left:-1.25rem;appearance:none"
} : 0;
var labelBaseStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("vertical-align:middle;padding-top:0.0625rem;position:relative;display:block;cursor:pointer;&:before{content:\"\";display:block;position:absolute;background:#fff;border-radius:50%;cursor:pointer;border:1px solid ", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{line-height:1.6;}" + ( true ? "" : 0),  true ? "" : 0);
var labelStyle = {
  "default": /*#__PURE__*/(0,emotion_react_browser_esm.css)(labelBaseStyle, ";padding-left:2rem;font-size:", typographyStyle/* fontSize.body */.JB.body, ";min-height:1.375rem;&:before{top:0;left:0;width:1.25rem;height:1.25rem;}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{padding-left:1.875rem;font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";&:before{top:0;left:0;width:1.25rem;height:1.25rem;}}" + ( true ? "" : 0),  true ? "" : 0),
  small: /*#__PURE__*/(0,emotion_react_browser_esm.css)(labelBaseStyle, ";padding-left:1.75rem;padding-top:0.0625rem;font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";min-height:1.25rem;&:before{top:0;left:0;width:1.125rem;height:1.125rem;}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{padding-left:1.75rem;font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";&:before{top:0;left:0;width:1.125rem;height:1.125rem;}}" + ( true ? "" : 0),  true ? "" : 0),
  large: /*#__PURE__*/(0,emotion_react_browser_esm.css)(labelBaseStyle, ";padding-left:2.125rem;font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";min-height:2rem;&:before{top:0.125rem;left:0;width:1.25rem;height:1.25rem;}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{padding-left:2.125rem;font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";&:before{top:0.1875rem;left:0;width:1.25rem;height:1.25rem;}}" + ( true ? "" : 0),  true ? "" : 0)
};
var labelCheckedBaseStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("&:before{background:", colorStyle/* accentColor.primaryColor2 */.z.primaryColor2, ";border-color:", colorStyle/* accentColor.primaryColor2 */.z.primaryColor2, ";}&:after{content:\"\";display:block;position:absolute;background:#fff;border-radius:50%;cursor:pointer;}" + ( true ? "" : 0),  true ? "" : 0);
var labelCheckedStyle = {
  "default": /*#__PURE__*/(0,emotion_react_browser_esm.css)(labelCheckedBaseStyle, ";&:after{top:0.375rem;left:0.375rem;width:0.625rem;height:0.625rem;}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{&:after{top:calc((1.25rem + 2px - 0.625rem) / 2);left:calc((1.25rem + 2px - 0.625rem) / 2);width:0.625rem;height:0.625rem;}}" + ( true ? "" : 0),  true ? "" : 0),
  small: /*#__PURE__*/(0,emotion_react_browser_esm.css)(labelCheckedBaseStyle, ";&:after{top:0.3125rem;left:0.3125rem;width:0.625rem;height:0.625rem;}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{&:after{top:0.3125rem;left:0.3125rem;width:0.625rem;height:0.625rem;}}" + ( true ? "" : 0),  true ? "" : 0),
  large: /*#__PURE__*/(0,emotion_react_browser_esm.css)(labelCheckedBaseStyle, ";&:after{top:0.5rem;left:0.375rem;width:0.625rem;height:0.625rem;}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{&:after{top:calc(((1.25rem + 2px - 0.625rem) / 2) + 0.1875rem);left:calc((1.25rem + 2px - 0.625rem) / 2);width:0.625rem;height:0.625rem;}}" + ( true ? "" : 0),  true ? "" : 0)
};
var labelColorStyle = {
  labelDark: /*#__PURE__*/(0,emotion_react_browser_esm.css)("color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";" + ( true ? "" : 0),  true ? "" : 0),
  labelLight:  true ? {
    name: "220rkc",
    styles: "color:#fff"
  } : 0,
  labelMix: /*#__PURE__*/(0,emotion_react_browser_esm.css)("color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{color:#fff;}" + ( true ? "" : 0),  true ? "" : 0)
};
var radioButtonBorderColorStyle = {
  none:  true ? {
    name: "zy8tx6",
    styles: "&:before{border-color:#fff;}"
  } : 0,
  primary: /*#__PURE__*/(0,emotion_react_browser_esm.css)("&:before{border-color:", colorStyle/* borderColor.primaryDarkColor */.tv.primaryDarkColor, ";}" + ( true ? "" : 0),  true ? "" : 0),
  secondary: /*#__PURE__*/(0,emotion_react_browser_esm.css)("&:before{border-color:", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";}" + ( true ? "" : 0),  true ? "" : 0)
};
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/components/form/InputError.tsx
var InputError = __webpack_require__(44464);
// EXTERNAL MODULE: ./main/javascripts/components/form/FieldDescription.tsx
var FieldDescription = __webpack_require__(73629);
// EXTERNAL MODULE: ./main/javascripts/utils/StringUtil.tsx
var StringUtil = __webpack_require__(56896);
;// CONCATENATED MODULE: ./main/javascripts/components/form/RadioButtonBlock.tsx


function RadioButtonBlock_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function RadioButtonBlock_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RadioButtonBlock_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RadioButtonBlock_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var RadioButtonBlock = function RadioButtonBlock(props) {
  var namespace = props.namespace,
      label = props.label,
      options = props.options,
      description = props.description,
      _props$input = props.input,
      input = _props$input === void 0 ? {} : _props$input,
      checkedValue = props.checkedValue,
      error = props.error,
      styleKey = props.styleKey,
      displayStyle = props.displayStyle,
      widthStyle = props.widthStyle,
      labelStyleKey = props.labelStyleKey,
      borderColorStyleKey = props.borderColorStyleKey;
  var innerStyles = innerStyle;

  if (displayStyle) {
    innerStyles = /*#__PURE__*/(0,emotion_react_browser_esm.css)(innerStyles, ";display:", displayStyle, ";" + ( true ? "" : 0),  true ? "" : 0);
  }

  if (displayStyle === "flex") {
    innerStyles = /*#__PURE__*/(0,emotion_react_browser_esm.css)(innerStyles, ";flex-wrap:wrap;column-gap:", spaceStyle/* space.atom2x */.D.atom2x, ";" + ( true ? "" : 0),  true ? "" : 0);
  }

  if (widthStyle) {
    innerStyles = /*#__PURE__*/(0,emotion_react_browser_esm.css)(innerStyles, ";&>label{width:", widthStyle, ";}" + ( true ? "" : 0),  true ? "" : 0);
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: RadioButtonBlock_blockStyle,
    children: [label && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Label/* Label */._, RadioButtonBlock_objectSpread({}, label)), description && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FieldDescription/* FieldDescription */.D, {
      children: (0,StringUtil/* nl2br */.hU)(description)
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: innerStyles,
      children: options.map(function (_ref, index) {
        var text = _ref.text,
            value = _ref.value,
            _ref$caption = _ref.caption,
            caption = _ref$caption === void 0 ? null : _ref$caption;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RadioButton, RadioButtonBlock_objectSpread(RadioButtonBlock_objectSpread({
            label: text,
            value: value
          }, input), {}, {
            checked: checkedValue === value,
            styleKey: styleKey,
            labelStyleKey: labelStyleKey,
            borderColorStyleKey: borderColorStyleKey
          }), index), caption && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: captionBlockStyle,
            children: caption
          })]
        }, index);
      })
    }), error && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputError/* InputError */.p, {
      namespace: namespace,
      errorMessage: error.message,
      label: input.name
    })]
  });
};
var RadioButtonBlock_blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:100%;padding:calc(", spaceStyle/* space.atom */.D.atom, " - (", typographyStyle/* lineHeight.body1 */.Nv.body1, " - ", typographyStyle/* fontSize.body */.JB.body, ") / 2) ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom2x */.D.atom2x, ";box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);
var captionBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:0 0 ", spaceStyle/* space.atom */.D.atom, " 2.125rem;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{padding-left:1.75rem;}" + ( true ? "" : 0),  true ? "" : 0);
var innerStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)( true ? "" : 0,  true ? "" : 0);

/***/ })

}]);